import { notifyError, notifySuccess } from 'lib/Notifications';
import { VerificationChannel } from 'models/mobileVerification';
import api from 'api';

const resendOtp = async (channel?: VerificationChannel) => {
	if (!channel) {
		channel = VerificationChannel.WhatsApp;
	}

	const errorMessage = 'Something went wrong, the OTP could not be sent';
	const successMessage = `An OTP has been sent to you via ${
		channel === 'sms' ? 'SMS' : 'WhatsApp'
	}`;

	try {
		const response = await api.user.resendVerificationCode(channel);
		if (response.status >= 200 && response.status < 300) {
			notifySuccess(successMessage);
		} else {
			notifyError(response.data.error.message || errorMessage);
		}
	} catch (err) {
		notifyError(errorMessage);
	}
};

export default {
	resendOtp,
};
